import React, { useEffect, useState } from "react";
import eventEmitter from "../../../shared/events";

import ReactTable from "react-table";
import ReactTablePagination from "components/task-list/components/pagination";
import Modal from "../../../components/modal";
import NoteLoader from "../../../components/notes/components/note-loader";

import { useSearchTasks } from "shared/hooks/api/use-search-task";
import { usePagination } from "shared/hooks/use-pagination";
import { buildColumns, DEFAULT_SETTINGS } from "../lib/constants";
import { SECTION_MAP } from "../../../components/task-list/lib/constants";
import { TaskStatus } from "shared/constants/task-status";
import { TASK_STATUSES } from "components/duplicate-staging/lib/constants";
import { DEFAULT_SORT } from "components/duplicate-staging/lib/constants";
import { getStorageValue } from "shared/storage";

export const WorkflowTaskList = ({ usersWithAssignments, disableNotes, ...props }) => {
    const storedSettings = getStorageValue("task-list-settings") || {};
    const useStoredOrDefault = (storedKey, defaultValue) => {
        if (!storedKey) {
            return defaultValue;
        }

        const storedValue = getStorageValue(storedKey);

        return storedValue ? storedValue : defaultValue;
    };
    const storedSort = useStoredOrDefault(props.storageSortValue, DEFAULT_SORT);
    const storedFilter = useStoredOrDefault(props.storageFilterValue, DEFAULT_SETTINGS.filtered);
    const useSettings = { ...props.settings, ...storedSettings, sorted: storedSort, filtered: storedFilter };
    const defaultFilterValues = [{ id: "state", value: TaskStatus.TO_DO }];

    const [noteSettings, setNoteSettings] = useState(null);
    const [taskListItems, setTaskListItems] = useState([]);
    const [state, setState] = useState(useSettings);

    const updateNoteSettings = (newSettings) => {
        setNoteSettings({ ...newSettings, taskType: SECTION_MAP[props.taskType].noteKey, isReadOnly: disableNotes });
    };

    const { mutate: searchTasks, data: taskList, isSuccess: searchTasksSuccess } = useSearchTasks(props.taskType);
    const [
        { pageNumber, pageSize, sortBy, totalCount, totalPages, searchParams, pagingParams, filteredValues },
        { setPageSize, setPage, setSortBy, setTotalCount, search },
    ] = usePagination({
        defaultFilters: defaultFilterValues,
        defaultValues: {
            pageSize: storedSettings.pageSize || 10,
            sortBy: storedSort || DEFAULT_SORT,
        },
        filterOutputMappings: {
            cxHClient: "cxhClient",
            receivedOn: "shipment.receivedOn",
        },
        onSearchParamsSet: () => {},
        callback: (a) => {
            search(defaultFilterValues);
        },
    });

    useEffect(() => {
        eventEmitter.on("UPDATE_NOTE_SETTINGS", updateNoteSettings);

        return () => {
            eventEmitter.removeListener("UPDATE_NOTE_SETTINGS", updateNoteSettings);
        };
    }, []);

    useEffect(() => {
        searchTasks({ searchParams, pagingParams, isUsingExternalFilters: false });
    }, [searchParams, pagingParams, props.updatePulse]);

    useEffect(() => {
        search(defaultFilterValues);
    }, [props.clearFilters]);

    useEffect(() => {
        if (searchTasksSuccess && taskList) {
            setTotalCount(taskList.totalRecordCount);
            setTaskListItems(taskList.items);
        }
    }, [searchTasksSuccess, taskList]);

    useEffect(() => {
        if (props.appendSettings) {
            setState({
                ...state,
                ...props.appendSettings,
            });
        }
    }, [props.appendSettings]);

    const updateSelectedUpc = (obj, isRemove) => {
        if (isRemove === "true") {
            props.setSelectedProducts(props.selected.filter((i) => i.key !== obj.key));
        } else {
            props.setSelectedProducts([...props.selected, obj]);
        }
    };

    const setAllUpcs = (selections) => {
        props.setSelectedProducts([...selections]);
    };

    const updateTeamFilter = (team) => {
        props.setTeamFilter(team);
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const closeNotesModal = () => {
        setNoteSettings(null);
    };

    const selectedIds = props.selected.map((s) => s.key);

    return (
        <>
            <ReactTable
                manual
                appendSettings={props.appendSettings}
                data={taskListItems}
                filtered={filteredValues}
                filterable
                sortable
                columns={buildColumns(
                    updateSelectedUpc,
                    setAllUpcs,
                    selectedIds,
                    props.locations,
                    props.assignments,
                    TASK_STATUSES,
                    usersWithAssignments,
                    updateTeamFilter,
                    null,
                    true
                )}
                multiSort
                minRows={5}
                totalRecords={totalCount}
                showPagination
                PaginationComponent={ReactTablePagination}
                onPageChange={handlePageChange}
                onPageSizeChange={setPageSize}
                onSortedChange={setSortBy}
                onFilteredChange={search}
                sorted={sortBy}
                page={pageNumber}
                pageSize={pageSize}
                pages={totalPages}
            />
            <Modal
                show={!!noteSettings}
                onClose={closeNotesModal}
            >
                <NoteLoader settings={noteSettings} />
            </Modal>
        </>
    );
};
